const draftFields = {
  name: 'is_special',
  type: 'checkbox',
}

const scheduledFields = {
  name: 'is_special',
  type: 'checkbox',
  disabled: true,
}

const specialFields = {
  Draf: draftFields,
  Dikonfirmasi: draftFields,
  'Menunggu Vendor': scheduledFields,
  'Ditolak': scheduledFields,
  'Diterima Vendor': scheduledFields,
  Dijadwalkan: scheduledFields,
  'Dijadwalkan Ulang': scheduledFields,
  Dijalankan: scheduledFields,
  Diambil: scheduledFields,
  Terkirim: scheduledFields,
  Dibatalkan: scheduledFields,
  'Sedang Transit': scheduledFields,

  default: draftFields,
}

export default specialFields
